module.exports = __webpack_public_path__ + "img/018-south-korea.50ffa57e.svg";